import React, {Component} from 'react'

class NoFile extends Component {
    render() {
        return (
            <tr className='NoFile'>
                <td colSpan={20}><i>No items</i></td>
            </tr>
        )
    }
}

export default NoFile
